module.exports = __webpack_public_path__ + "static/media/recipe rambuWEB.654e857b.jpg";